<div class="root" *transloco="let t; read: 'permit.details.export'">
    <ng-container *ngIf="permit$ | async as permit">
        <div class="buttons">
            <ng-container *ngIf="canExportRegularPermit(currentUserIsIssuer$ | async, currentUserIsSuperintendent$ | async, currentUserRoles$ | async)">
                <div class="buttons__export" [class.buttons__export--loading]="waitingForDownload" [downloadFile]="pdfUrl" (click)="beginDownload()"
                    (done)="endDownload()" [innerHTML]="t('export')"></div>
            </ng-container>
            <ng-container *ngIf="(currentUserIsIssuer$ | async) || (currentUserIsSuperintendent$ | async)">
                <div class="buttons__email" (click)="openExportPermitEmailModal()" [innerHTML]="t('mail')"></div>
            </ng-container>
            <button *ngIf="hasFlammableAtexContext(permit)" type="button" class="buttons__export"
                [class.buttons__export--loading]="waitingForFlammableAtexDownload"
                [downloadFile]="flammableAtexPdfUrl" (click)="beginFlammableAtexDownload()"
                (done)="endFlammableAtexDownload()">{{ t("exportFlammableAtexPermit") }}</button>
            <button *ngIf="showGasFreeDeclaration(permit)" type="button" class="buttons__export"
                [class.buttons__export--loading]="waitingForGasFreeDownload"
                [downloadFile]="gasFreeDeclarationPdfUrl" (click)="beginGasFreeDownload()"
                (done)="endGasFreeDownload()">{{ t("exportGasFreeDeclaration") }}</button>
        </div>
    </ng-container>
</div>
